{
  "4 types of outbound calls: Connected, Not Connected, Canceled, and System Failure": "4 types of outbound calls: Connected, Not Connected, Canceled, and System Failure",
  "<0><0>AI Call Credit</0><1>Calls are counted toward your monthly call credit usage when the interaction with the AI Receptionist is at least 20 seconds and the caller engages in the conversation.</1></0>": "<0><0>AI Call Credit</0><1>Calls are counted toward your monthly call credit usage when the interaction with the AI Receptionist is at least 20 seconds and the caller engages in the conversation.</1></0>",
  "<0><0>AI Call Outcome</0><1><0>What It Helps With</0><1>Determine if the AI Receptionist was able to handle the call on its own or if it needed to involve your office staff.</1></1><2><0>How It's Defined</0><1><0></0><1></1><2></2><3></3><4></4></1></2></0>": "<0><0>AI Call Outcome</0><1><0>What It Helps With</0><1>Determine if the AI Receptionist was able to handle the call on its own or if it needed to involve your office staff.</1></1><2><0>How It's Defined</0><1><0></0><1></1><2></2><3></3><4></4></1></2></0>",
  "<0><0>AI Receptionist Outcomes</0><1><0>What They Help With</0><1>See how calls are being handled by your AI Receptionist and whether patients may still need assistance.</1></1><2><0>How They're Defined</0><1>{descriptions.map((config) => (\n                  <EventSection key={config.event} config={config} />\n                ))}</1></2></0>": "<0><0>AI Receptionist Outcomes</0><1><0>What They Help With</0><1>See how calls are being handled by your AI Receptionist and whether patients may still need assistance.</1></1><2><0>How They're Defined</0><1>{descriptions.map((config) => (\n                  <EventSection key={config.event} config={config} />\n                ))}</1></2></0>",
  "<0><0>Call Result</0><1><0>What It Helps With</0><1>Assess how well incoming calls are being handled by your staff or by your AI Receptionist.</1></1><2><0><0>How It's Defined</0><1>The call result reflects the <2>final status</2> of the call. For example, if the AI answers but your staff misses the transfer, the call result will show as Missed.</1></0><1><0></0><1></1><2></2><3></3></1></2></0>": "<0><0>Call Result</0><1><0>What It Helps With</0><1>Assess how well incoming calls are being handled by your staff or by your AI Receptionist.</1></1><2><0><0>How It's Defined</0><1>The call result reflects the <2>final status</2> of the call. For example, if the AI answers but your staff misses the transfer, the call result will show as Missed.</1></0><1><0></0><1></1><2></2><3></3></1></2></0>",
  "<0>AI Receptionist</0> <2>answered call</2>": "<0>AI Receptionist</0> <2>answered call</2>",
  "<0>AI Receptionist</0> <2>transferred call</2>": "<0>AI Receptionist</0> <2>transferred call</2>",
  "<strong>AI Receptionist</strong> <body>cancels appointment</body>": "<strong>AI Receptionist</strong> <body>cancels appointment</body>",
  "<strong>AI Receptionist</strong> <body>confirms appointment</body>": "<strong>AI Receptionist</strong> <body>confirms appointment</body>",
  "<strong>AI Receptionist</strong> <body>created Appointment Request</body>": "<strong>AI Receptionist</strong> <body>created Appointment Request</body>",
  "<strong>AI Receptionist</strong> <body>reschedules appointment</body>": "<strong>AI Receptionist</strong> <body>reschedules appointment</body>",
  "<strong>AI Receptionist</strong> <body>schedules appointment</body>": "<strong>AI Receptionist</strong> <body>schedules appointment</body>",
  "> 3.5": "> 3.5",
  "AI Call Credit": "AI Call Credit",
  "AI Call Outcome": "AI Call Outcome",
  "AI Receptionist": "AI Receptionist",
  "AI Receptionist Outcomes": "AI Receptionist Outcomes",
  "Abandoned": "Abandoned",
  "About this Call": "About this Call",
  "About this voicemail": "About this voicemail",
  "Add Tag": "Add Tag",
  "Add tag": "Add tag",
  "Added to Schedule": "Added to Schedule",
  "All": "All",
  "An error occurred while preparing your download. Please try again later.": "An error occurred while preparing your download. Please try again later.",
  "Answered": "Answered",
  "Appointment Requested": "Appointment Requested",
  "Are you sure you want to delete this Call Recording?": "Are you sure you want to delete this Call Recording?",
  "Are you sure you want to delete this voicemail?": "Are you sure you want to delete this voicemail?",
  "Averages are calculated from the events in this low-quality interval.": "Averages are calculated from the events in this low-quality interval.",
  "Before downloading the CSV, please select your desired criteria for the Call History data. Filters that are currently applied to the Call History table will not transfer to the CSV file.": "Before downloading the CSV, please select your desired criteria for the Call History data. Filters that are currently applied to the Call History table will not transfer to the CSV file.",
  "Beta": "Beta",
  "Call": "Call",
  "Call Details": "Call Details",
  "Call Direction": "Call Direction",
  "Call Ended": "Call Ended",
  "Call Group": "Call Group",
  "Call History": "Call History",
  "Call Insights": "Call Insights",
  "Call Intelligence is not available for this location.": "Call Intelligence is not available for this location.",
  "Call Metrics": "Call Metrics",
  "Call Path": "Call Path",
  "Call Path Overview": "Call Path Overview",
  "Call Path is unavailable due to system error.": "Call Path is unavailable due to system error.",
  "Call Quality": "Call Quality",
  "Call Queue": "Call Queue",
  "Call Recording": "Call Recording",
  "Call Recording successfully deleted.": "Call Recording successfully deleted.",
  "Call Terminated": "Call Terminated",
  "Call from {{ name }}": "Call from {{ name }}",
  "Call from {{name}}": "Call from {{name}}",
  "Call to {{name}}": "Call to {{name}}",
  "Call transferred: ": "Call transferred: ",
  "Caller": "Caller",
  "Caller Intent": "Caller Intent",
  "Caller hung up": "Caller hung up",
  "Caller requested to speak directly with staff": "Caller requested to speak directly with staff",
  "Canceled": "Canceled",
  "Cancelled": "Cancelled",
  "Category": "Category",
  "Clear": "Clear",
  "Click here to add or remove Users and Devices from your Team Status dashboard.": "Click here to add or remove Users and Devices from your Team Status dashboard.",
  "Click the bar to learn more": "Click the bar to learn more",
  "Close": "Close",
  "Close panel": "Close panel",
  "Close unused browser tabs to reduce internet traffic": "Close unused browser tabs to reduce internet traffic",
  "Close unused running apps on your computer": "Close unused running apps on your computer",
  "Conduct an internet speed test": "Conduct an internet speed test",
  "Confirmed": "Confirmed",
  "Connected": "Connected",
  "Contact Name": "Contact Name",
  "Contact Number": "Contact Number",
  "Contact Type": "Contact Type",
  "Contact created successfully.": "Contact created successfully.",
  "Continued over text": "Continued over text",
  "Couldn't load the data. Please try again.": "Couldn't load the data. Please try again.",
  "Create Contact": "Create Contact",
  "Custom": "Custom",
  "Custom Range": "Custom Range",
  "Customer Sentiment": "Customer Sentiment",
  "Date Range": "Date Range",
  "Date Range must be {{maxRange}} days or less. You have {{currentRange}} days selected.": "Date Range must be {{maxRange}} days or less. You have {{currentRange}} days selected.",
  "Delete Call Recording?": "Delete Call Recording?",
  "Delete Recording": "Delete Recording",
  "Delete Voicemail": "Delete Voicemail",
  "Delete Voicemail Message?": "Delete Voicemail Message?",
  "Department": "Department",
  "Device": "Device",
  "Device Name": "Device Name",
  "Done": "Done",
  "Download CSV": "Download CSV",
  "Download Data": "Download Data",
  "Download Data to CSV": "Download Data to CSV",
  "Download Recording": "Download Recording",
  "Download Voicemail": "Download Voicemail",
  "Duration": "Duration",
  "End date must be after the start date": "End date must be after the start date",
  "Ensure that your network equipment (router and/or switch) is set up properly": "Ensure that your network equipment (router and/or switch) is set up properly",
  "Ensure that your network equipment is not overloaded with plugged in devices": "Ensure that your network equipment is not overloaded with plugged in devices",
  "Error": "Error",
  "Error: ": "Error: ",
  "Events": "Events",
  "FAQ": "FAQ",
  "Failed to add tag.": "Failed to add tag.",
  "Failed to copy shortlink.": "Failed to copy shortlink.",
  "Failed to remove tag.": "Failed to remove tag.",
  "Failed to submit feedback. Please try again.": "Failed to submit feedback. Please try again.",
  "Fallback": "Fallback",
  "Feedback (Optional)": "Feedback (Optional)",
  "Feedback submitted successfully. Thank you!": "Feedback submitted successfully. Thank you!",
  "Filter Calls By AI Receptionist & Staff Members": "Filter Calls By AI Receptionist & Staff Members",
  "Filter Calls By Staff Members": "Filter Calls By Staff Members",
  "Filter your call history to see activity for specific office users, including calls managed by the AI Receptionist.": "Filter your call history to see activity for specific office users, including calls managed by the AI Receptionist.",
  "Filter your call history to see activity for specific office users.": "Filter your call history to see activity for specific office users.",
  "For Desk Phone": "For Desk Phone",
  "For Softphone": "For Softphone",
  "Forward Voicemail": "Forward Voicemail",
  "Forwarded + Abandoned": "Forwarded + Abandoned",
  "Forwarded + Connected": "Forwarded + Connected",
  "Forwarded + Not Connected": "Forwarded + Not Connected",
  "Forwarded Calls": "Forwarded Calls",
  "Forwarded now has 3 sub-categories: Connected, Not Connected, and Abandoned": "Forwarded now has 3 sub-categories: Connected, Not Connected, and Abandoned",
  "Forwarding Number": "Forwarding Number",
  "Give feedback": "Give feedback",
  "Got It": "Got It",
  "Got it": "Got it",
  "Here's what's changing:": "Here's what's changing:",
  "High": "High",
  "Hold tight, we're working on getting this data": "Hold tight, we're working on getting this data",
  "Home Number": "Home Number",
  "How They're Defined": "How They're Defined",
  "Inbound Calls": "Inbound Calls",
  "Inbound and outbound call records will display here.": "Inbound and outbound call records will display here.",
  "Inbound audio stream": "Inbound audio stream",
  "Incoming Call": "Incoming Call",
  "Incomplete: ": "Incomplete: ",
  "Is this helpful?": "Is this helpful?",
  "Issues Detected": "Issues Detected",
  "It doesn't look like there's any data to show here": "It doesn't look like there's any data to show here",
  "Jitter (avg.)": "Jitter (avg.)",
  "Jitter (max.)": "Jitter (max.)",
  "Jitter is the variation in the time it takes for voice data packets to reach their destination. Jitter occurs when these packets arrive at different times, causing variations in the arrival times of the audio segments. Jitter can result in uneven, choppy, or garbled audio.": "Jitter is the variation in the time it takes for voice data packets to reach their destination. Jitter occurs when these packets arrive at different times, causing variations in the arrival times of the audio segments. Jitter can result in uneven, choppy, or garbled audio.",
  "Last 1 Year": "Last 1 Year",
  "Last 14 Days": "Last 14 Days",
  "Last 30 Days": "Last 30 Days",
  "Last 60 Days": "Last 60 Days",
  "Last 7 Days": "Last 7 Days",
  "Last 90 Days": "Last 90 Days",
  "Less": "Less",
  "Limit heavy internet use during busy hours": "Limit heavy internet use during busy hours",
  "Limit the number of devices using your internet": "Limit the number of devices using your internet",
  "Location": "Location",
  "Location(s)": "Location(s)",
  "Locations": "Locations",
  "Loud and clear – your connection was top-notch!": "Loud and clear – your connection was top-notch!",
  "Low": "Low",
  "Low Quality": "Low Quality",
  "Low Quality Interval": "Low Quality Interval",
  "MOS": "MOS",
  "MOS (avg.)": "MOS (avg.)",
  "MOS (min.)": "MOS (min.)",
  "Manage": "Manage",
  "Manage Users and Devices": "Manage Users and Devices",
  "Mark Read": "Mark Read",
  "Mark Unread": "Mark Unread",
  "Maximum {{count}} office staff selected. To select this user, deselect another user. To select all office staff, click \"Office Staff.\"_one": "Maximum {{count}} office staff selected. To select this user, deselect another user. To select all office staff, click \"Office Staff.\"",
  "Maximum {{count}} office staff selected. To select this user, deselect another user. To select all office staff, click \"Office Staff.\"_other": "Maximum {{count}} office staff selected. To select this user, deselect another user. To select all office staff, click \"Office Staff.\"",
  "Media deletion failed.": "Media deletion failed.",
  "Message": "Message",
  "Missed": "Missed",
  "Missed / Abandoned": "Missed / Abandoned",
  "Mobile Number": "Mobile Number",
  "Monitor your team’s phone activity in real time.": "Monitor your team’s phone activity in real time.",
  "More": "More",
  "Needs attention: ": "Needs attention: ",
  "Network Performance": "Network Performance",
  "Next": "Next",
  "No Data": "No Data",
  "No Items to Display": "No Items to Display",
  "No call quality data available for this call.": "No call quality data available for this call.",
  "No device found": "No device found",
  "No message": "No message",
  "No option dialed": "No option dialed",
  "No tags added": "No tags added",
  "No transcript available.": "No transcript available.",
  "No, Cancel": "No, Cancel",
  "Not Connected": "Not Connected",
  "Not enough call quality data to display a timeline.": "Not enough call quality data to display a timeline.",
  "Not used": "Not used",
  "Nothing to transcribe.": "Nothing to transcribe.",
  "Office Number": "Office Number",
  "Office Staff": "Office Staff",
  "Office User": "Office User",
  "Office Users": "Office Users",
  "Office assisted": "Office assisted",
  "Other": "Other",
  "Other Number": "Other Number",
  "Out of call credits. AI Receptionist was skipped in this call.": "Out of call credits. AI Receptionist was skipped in this call.",
  "Out of call credits. AI Receptionist was skipped in this call. Add a fallback step to prevent future calls from being disconnected.": "Out of call credits. AI Receptionist was skipped in this call. Add a fallback step to prevent future calls from being disconnected.",
  "Out of call credits. AI Receptionist was skipped in this call. Alert your admin to add a fallback step to prevent future calls from being disconnected.": "Out of call credits. AI Receptionist was skipped in this call. Alert your admin to add a fallback step to prevent future calls from being disconnected.",
  "Out of credits": "Out of credits",
  "Outbound Calls": "Outbound Calls",
  "Outbound audio stream": "Outbound audio stream",
  "Outbound call": "Outbound call",
  "Overview": "Overview",
  "Packet Loss (avg.)": "Packet Loss (avg.)",
  "Packet Loss (max.)": "Packet Loss (max.)",
  "Packet loss occurs when voice data packets traveling across a network fail to reach their destination. When packets are lost, it can result in gaps or distortion in the audio, leading to a degraded call quality.": "Packet loss occurs when voice data packets traveling across a network fail to reach their destination. When packets are lost, it can result in gaps or distortion in the audio, leading to a degraded call quality.",
  "Phone Number Name": "Phone Number Name",
  "Phone Number Searches Must be Exactly 10 Digits": "Phone Number Searches Must be Exactly 10 Digits",
  "Phone Tree": "Phone Tree",
  "Phone number searches must be exactly 10 digits in order to return a match.": "Phone number searches must be exactly 10 digits in order to return a match.",
  "Play Message": "Play Message",
  "Please share details about the issues in the Network Performance information.": "Please share details about the issues in the Network Performance information.",
  "Please share details about what you found valuable in the Network Performance information.": "Please share details about what you found valuable in the Network Performance information.",
  "Precise Call Results": "Precise Call Results",
  "Precise Result": "Precise Result",
  "Previous": "Previous",
  "Processing...": "Processing...",
  "Provide Additional Feedback": "Provide Additional Feedback",
  "Quality Alert Sent": "Quality Alert Sent",
  "Recommendations": "Recommendations",
  "Recommended MOS": "Recommended MOS",
  "Representative": "Representative",
  "Rescheduled": "Rescheduled",
  "Restart your phones periodically": "Restart your phones periodically",
  "Result": "Result",
  "Results are becoming Precise Results": "Results are becoming Precise Results",
  "Routing and System Issues": "Routing and System Issues",
  "Scheduling": "Scheduling",
  "Scheduling Outcome": "Scheduling Outcome",
  "Search name or 10-digit number": "Search name or 10-digit number",
  "See how calls are being properly or improperly resolved by staff and your phone system.": "See how calls are being properly or improperly resolved by staff and your phone system.",
  "See how calls are being properly or improperly resolved by staff, the AI receptionist, and your phone system.": "See how calls are being properly or improperly resolved by staff, the AI receptionist, and your phone system.",
  "Select AI Receptionist Outcomes": "Select AI Receptionist Outcomes",
  "Select Office User": "Select Office User",
  "Select date range": "Select date range",
  "Sent to Play Message": "Sent to Play Message",
  "Sent to Voicemail": "Sent to Voicemail",
  "Service Issues": "Service Issues",
  "Shortlink copied successfully!": "Shortlink copied successfully!",
  "Show Less": "Show Less",
  "Show More": "Show More",
  "Stable": "Stable",
  "Stable Performance": "Stable Performance",
  "Stable Quality": "Stable Quality",
  "Submit": "Submit",
  "Successfully assisted the patient": "Successfully assisted the patient",
  "Successfully assisted the patient: ": "Successfully assisted the patient: ",
  "Successfully removed tag.": "Successfully removed tag.",
  "System Failure": "System Failure",
  "System experienced temporary disruption": "System experienced temporary disruption",
  "Tag Voicemail": "Tag Voicemail",
  "Tag added successfully.": "Tag added successfully.",
  "Tags": "Tags",
  "Tasks": "Tasks",
  "Tasks are not available for this location.": "Tasks are not available for this location.",
  "Team Status": "Team Status",
  "The AI Receptionist <2>could not answer</2> the call or <6>could not finish</6> assisting the caller. This can happen when the set up is incomplete or when the system is experiencing a temporary disruption.": "The AI Receptionist <2>could not answer</2> the call or <6>could not finish</6> assisting the caller. This can happen when the set up is incomplete or when the system is experiencing a temporary disruption.",
  "The AI Receptionist <2>handed the conversation off </2>for further assistance, either by transferring the caller to office staff or by moving the conversation to text. This can happen when the request isn’t supported or when the caller asks to speak with staff.": "The AI Receptionist <2>handed the conversation off </2>for further assistance, either by transferring the caller to office staff or by moving the conversation to text. This can happen when the request isn’t supported or when the caller asks to speak with staff.",
  "The AI Receptionist cancelled an appointment for the patient.": "The AI Receptionist cancelled an appointment for the patient.",
  "The AI Receptionist confirmed an appointment for the patient.": "The AI Receptionist confirmed an appointment for the patient.",
  "The AI Receptionist could not answer the call or the call was disrupted. This can happen when the set up is incomplete or when the system is experiencing a temporary disruption.": "The AI Receptionist could not answer the call or the call was disrupted. This can happen when the set up is incomplete or when the system is experiencing a temporary disruption.",
  "The AI Receptionist created an Appointment Request for the patient. Review your requests and follow up with patients under Requests in Schedule Pulse.": "The AI Receptionist created an Appointment Request for the patient. Review your requests and follow up with patients under Requests in Schedule Pulse.",
  "The AI Receptionist rescheduled an appointment for the patient.": "The AI Receptionist rescheduled an appointment for the patient.",
  "The AI Receptionist scheduled an appointment for the patient.": "The AI Receptionist scheduled an appointment for the patient.",
  "The AI Receptionist successfully handled the call on its own.": "The AI Receptionist successfully handled the call on its own.",
  "The AI Receptionist transferred the call and the office staff didn't answer or it went to voicemail. Transfers can happen when the caller’s request isn't supported or when the caller asks to speak with staff. The caller may still need assistance. ": "The AI Receptionist transferred the call and the office staff didn't answer or it went to voicemail. Transfers can happen when the caller’s request isn't supported or when the caller asks to speak with staff. The caller may still need assistance. ",
  "The AI Receptionist transferred the call to your office staff and they answered the call.": "The AI Receptionist transferred the call to your office staff and they answered the call.",
  "The AI Receptionist transferred the call to your office, but the <2>transfer was missed</2> . The caller may still need assistance.": "The AI Receptionist transferred the call to your office, but the <2>transfer was missed</2> . The caller may still need assistance.",
  "The Mean Opinion Score (MOS) indicates the overall quality of a VoIP call. It is a subjective measurement that aims to predict human perception of audio quality, but it correlates with objective metrics like packet loss, jitter, and latency. A score of 1 represents poor quality and 5 indicates excellent quality.": "The Mean Opinion Score (MOS) indicates the overall quality of a VoIP call. It is a subjective measurement that aims to predict human perception of audio quality, but it correlates with objective metrics like packet loss, jitter, and latency. A score of 1 represents poor quality and 5 indicates excellent quality.",
  "The call connected successfully.": "The call connected successfully.",
  "The call failed to connect.": "The call failed to connect.",
  "The call is forwarded and the caller hangs up (cancels) the call before the call connects.": "The call is forwarded and the caller hangs up (cancels) the call before the call connects.",
  "The call reached a dead end in the routing setup (e.g., a phone tree option with no destination) and Weave ended it automatically.": "The call reached a dead end in the routing setup (e.g., a phone tree option with no destination) and Weave ended it automatically.",
  "The call result reflects the final status of the call. To see the full journey of the call, go to Call Path in the Call Insights panel.": "The call result reflects the final status of the call. To see the full journey of the call, go to Call Path in the Call Insights panel.",
  "The call was answered by a Weave Phone or fully handled by the AI Receptionist.": "The call was answered by a Weave Phone or fully handled by the AI Receptionist.",
  "The call was answered by a Weave Phone.": "The call was answered by a Weave Phone.",
  "The call was answered by your staff or the AI Receptionist. ": "The call was answered by your staff or the AI Receptionist. ",
  "The call was destined for a Weave phone, but was not answered.": "The call was destined for a Weave phone, but was not answered.",
  "The call was forwarded externally to another phone number, but the call was not answered.": "The call was forwarded externally to another phone number, but the call was not answered.",
  "The call was hung up by the Weave Phone prior to being connected.": "The call was hung up by the Weave Phone prior to being connected.",
  "The call was not answered by your staff or by the AI Receptionist, and it went to voicemail.": "The call was not answered by your staff or by the AI Receptionist, and it went to voicemail.",
  "The call was routed straight to a recorded message, and the caller listened to the whole message.": "The call was routed straight to a recorded message, and the caller listened to the whole message.",
  "The call was routed straight to voicemail (no phones rang) and the caller left a message.": "The call was routed straight to voicemail (no phones rang) and the caller left a message.",
  "The call was terminated due to an incomplete call route configuration. Review your call routing if you see this result.": "The call was terminated due to an incomplete call route configuration. Review your call routing if you see this result.",
  "The caller <2>hung up </2>before the AI Receptionist could determine the outcome.": "The caller <2>hung up </2>before the AI Receptionist could determine the outcome.",
  "The caller hung up before reaching a Weave phone or leaving a voicemail message.": "The caller hung up before reaching a Weave phone or leaving a voicemail message.",
  "The caller hung up before reaching a Weave phone, conversing with the AI Receptionist, or leaving a voicemail message.": "The caller hung up before reaching a Weave phone, conversing with the AI Receptionist, or leaving a voicemail message.",
  "The caller hung up before the call could be answered or go to voicemail.": "The caller hung up before the call could be answered or go to voicemail.",
  "The forwarded call connected successfully.": "The forwarded call connected successfully.",
  "The forwarded call failed to connect.": "The forwarded call failed to connect.",
  "The system sends quality alerts when the Call Metrics drop below the thresholds for stable connections.": "The system sends quality alerts when the Call Metrics drop below the thresholds for stable connections.",
  "There may be additional events here. More events will be available as we continue enhancing Call Paths.": "There may be additional events here. More events will be available as we continue enhancing Call Paths.",
  "There was an error creating your contact. Please try again.": "There was an error creating your contact. Please try again.",
  "These values highlight the worst call quality detected.": "These values highlight the worst call quality detected.",
  "This metric represents the average MOS calculated from the values collected during the low-quality interval.": "This metric represents the average MOS calculated from the values collected during the low-quality interval.",
  "This metric represents the average jitter calculated from the values collected during the low-quality interval.": "This metric represents the average jitter calculated from the values collected during the low-quality interval.",
  "This metric represents the average packet loss calculated from the values collected during the low-quality interval.": "This metric represents the average packet loss calculated from the values collected during the low-quality interval.",
  "This metric represents the lowest MOS detected on the call. Recommended MOS is greater than 3.5 out of 5.": "This metric represents the lowest MOS detected on the call. Recommended MOS is greater than 3.5 out of 5.",
  "This metric represents the maximum jitter detected on the call.": "This metric represents the maximum jitter detected on the call.",
  "This metric represents the maximum packet loss detected on the call.": "This metric represents the maximum packet loss detected on the call.",
  "This voicemail is in a voicemail box you do not have access to. Contact your admin if you need access.": "This voicemail is in a voicemail box you do not have access to. Contact your admin if you need access.",
  "This voicemail is in a voicemail box({{vmBoxName}}) you do not have access to. Contact your admin if you need access.": "This voicemail is in a voicemail box({{vmBoxName}}) you do not have access to. Contact your admin if you need access.",
  "Time": "Time",
  "Time Before Abandonment": "Time Before Abandonment",
  "Time Range Date": "Time Range Date",
  "Time before abandonment": "Time before abandonment",
  "Time of Call": "Time of Call",
  "To select individual Office Staff, deselect \"Office Staff.\"": "To select individual Office Staff, deselect \"Office Staff.\"",
  "Today": "Today",
  "Transcript": "Transcript",
  "Transcription": "Transcription",
  "Transcription failed to load.": "Transcription failed to load.",
  "Transcription failed.": "Transcription failed.",
  "Transcription pending. This may take a few minutes.": "Transcription pending. This may take a few minutes.",
  "Transcription unavailable for calls before September 2023.": "Transcription unavailable for calls before September 2023.",
  "Transfer Missed": "Transfer Missed",
  "Transfer missed": "Transfer missed",
  "Transferred to Staff": "Transferred to Staff",
  "Unable to open task. Please try again.": "Unable to open task. Please try again.",
  "Unknown": "Unknown",
  "Unread voicemail": "Unread voicemail",
  "Used": "Used",
  "View Details": "View Details",
  "View Profile": "View Profile",
  "View call details": "View call details",
  "Voicemail": "Voicemail",
  "Voicemail Box": "Voicemail Box",
  "Voicemail Details": "Voicemail Details",
  "Voicemail Greeting": "Voicemail Greeting",
  "Voicemail deleted": "Voicemail deleted",
  "Voicemail read": "Voicemail read",
  "Voicemails will display here.": "Voicemails will display here.",
  "We're adding some new statuses:": "We're adding some new statuses:",
  "We've detected issues with your network that may have affected the audio quality of this call. You and your caller may have experienced choppy, distorted, or delayed audio. ": "We've detected issues with your network that may have affected the audio quality of this call. You and your caller may have experienced choppy, distorted, or delayed audio. ",
  "What They Help With": "What They Help With",
  "Work Number": "Work Number",
  "Yes, Delete": "Yes, Delete",
  "Yesterday": "Yesterday",
  "You have reached the maximum number of locations": "You have reached the maximum number of locations",
  "calls-filter": {
    "AI Call Outcome": "AI Call Outcome",
    "AI Receptionist Outcomes": "AI Receptionist Outcomes",
    "Apply": "Apply",
    "Call Direction": "Call Direction",
    "Clear": "Clear",
    "Continued over text": "Continued over text",
    "Filter": "Filter",
    "Inbound Calls": "Inbound Calls",
    "Incomplete": "Incomplete",
    "Last 1 Year": "Last 1 Year",
    "Last 14 Days": "Last 14 Days",
    "Last 30 Days": "Last 30 Days",
    "Last 60 Days": "Last 60 Days",
    "Last 7 Days": "Last 7 Days",
    "Last 90 Days": "Last 90 Days",
    "Needs attention": "Needs attention",
    "None of the selected Office Numbers belong to any of the selected Locations. No results will be available.": "None of the selected Office Numbers belong to any of the selected Locations. No results will be available.",
    "Office Numbers": "Office Numbers",
    "Office User": "Office User",
    "Office assisted": "Office assisted",
    "Outbound Calls": "Outbound Calls",
    "Pick your dates": "Pick your dates",
    "Results": "Results",
    "Results will be limited to the selected Locations and Office Numbers that match.": "Results will be limited to the selected Locations and Office Numbers that match.",
    "Select AI Receptionist Outcomes": "Select AI Receptionist Outcomes",
    "Select Locations": "Select Locations",
    "Select Office Numbers": "Select Office Numbers",
    "Select tags": "Select tags",
    "Successfully assisted patient": "Successfully assisted patient",
    "Time Period": "Time Period",
    "Today": "Today",
    "Unable to answer": "Unable to answer",
    "Yesterday": "Yesterday",
    "You have reached the max number of selections": "You have reached the max number of selections"
  },
  "devices": {
    "Assign Device": "Assign Device",
    "Assign Devices to Call Queue": "Assign Devices to Call Queue",
    "Cancel": "Cancel",
    "Close panel": "Close panel",
    "Device Name": "Device Name",
    "Devices": "Devices",
    "Done": "Done",
    "Failed to update the devices in the call queue.": "Failed to update the devices in the call queue.",
    "Failed to update the devices in the call queue. Permission denied.": "Failed to update the devices in the call queue. Permission denied.",
    "Location": "Location",
    "Manage Devices": "Manage Devices",
    "No Devices to Display": "No Devices to Display",
    "No id passed to call queue PUT request": "No id passed to call queue PUT request",
    "Remove Device": "Remove Device",
    "Save": "Save",
    "Search Devices": "Search Devices",
    "Successfully updated the devices in the call queue": "Successfully updated the devices in the call queue",
    "To add devices to this call queue, click “Assign Devices.”": "To add devices to this call queue, click “Assign Devices.”"
  },
  "to": "to",
  "unable to download the media": "unable to download the media",
  "unread-voicemail-widget": {
    "Add Tag": "Add Tag",
    "Are you sure you want to delete this voicemail?": "Are you sure you want to delete this voicemail?",
    "Call": "Call",
    "Delete Voicemail": "Delete Voicemail",
    "Delete Voicemail Message?": "Delete Voicemail Message?",
    "Download Voicemail": "Download Voicemail",
    "Failed to remove tag.": "Failed to remove tag.",
    "Forward Voicemail": "Forward Voicemail",
    "Mark Read": "Mark Read",
    "Mark Unread": "Mark Unread",
    "Message": "Message",
    "No Items to Display": "No Items to Display",
    "No data available": "No data available",
    "No locations selected": "No locations selected",
    "No, Cancel": "No, Cancel",
    "Phones": "Phones",
    "Successfully removed tag.": "Successfully removed tag.",
    "Table View": "Table View",
    "Tag removed successfully.": "Tag removed successfully.",
    "Transcript": "Transcript",
    "Unknown": "Unknown",
    "View Profile": "View Profile",
    "Voicemails will display here.": "Voicemails will display here.",
    "Yes, Delete": "Yes, Delete"
  },
  "voicemailDeletedError": "Failed to delete voicemail",
  "voicemailDeletedSuccess": "Voicemail deleted successfully",
  "voicemails": {
    "Are you sure you want to delete this voicemail?": "Are you sure you want to delete this voicemail?",
    "Cancel": "Cancel",
    "Choose which voicemail box you want to forward this voicemail to": "Choose which voicemail box you want to forward this voicemail to",
    "Current Voicemail Box": "Current Voicemail Box",
    "Delete Voicemail Message?": "Delete Voicemail Message?",
    "Destination voicemail box": "Destination voicemail box",
    "Enter the extension number": "Enter the extension number",
    "Forward": "Forward",
    "Forward Voicemail": "Forward Voicemail",
    "No Items to Display": "No Items to Display",
    "No, Cancel": "No, Cancel",
    "Phone Number Searches Must be Exactly 10 Digits": "Phone Number Searches Must be Exactly 10 Digits",
    "Phone number searches must be exactly 10 digits in order to return a match.": "Phone number searches must be exactly 10 digits in order to return a match.",
    "Remove voicemail from current Voicemail Box after forwarding": "Remove voicemail from current Voicemail Box after forwarding",
    "Showing results for {{timerange}}.": "Showing results for {{timerange}}.",
    "VoicemailForwardError": "Failed to forward voicemail",
    "VoicemailForwardedSuccess": "Voicemail forwarded successfully",
    "Voicemails": "Voicemails",
    "Voicemails will display here.": "Voicemails will display here.",
    "Yes, Delete": "Yes, Delete",
    "other (specify extension)": "other (specify extension)"
  },
  "voicemails-filter": {
    "Clear": "Clear",
    "Clear All Filters": "Clear All Filters",
    "Location": "Location",
    "Locations": "Locations",
    "Read": "Read",
    "Read Status": "Read Status",
    "Tags": "Tags",
    "Time Period": "Time Period",
    "Unread": "Unread",
    "Voicemail Box": "Voicemail Box"
  },
  "{callerName} selected <2>Option {dtmf.key}</2>": "{callerName} selected <2>Option {dtmf.key}</2>",
  "{{ count }} Task_one": "{{ count }} Task",
  "{{ count }} Task_other": "{{ count }} Tasks",
  "{{ name }} hung up": "{{ name }} hung up",
  "{{ taskCount }} Task": "{{ taskCount }} Task",
  "{{ taskCount }} Tasks": "{{ taskCount }} Tasks",
  "{{name}} left voicemail message": "{{name}} left voicemail message"
}
